<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icon_yueliangweidianji">
      <path id="Vector"
        d="M11.4981 4C11.6343 4.50694 11.71 5.04414 11.71 5.59647C11.71 8.971 8.97856 11.7024 5.60404 11.7024C5.0517 11.7024 4.5145 11.6267 4 11.4905C4.70366 14.0858 7.07188 16 9.89407 16C13.2686 16 16 13.2686 16 9.89407C16 7.07188 14.0933 4.70366 11.4981 4Z"
        fill="#626F8F" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'moon',
  props: {
    
  },
  data() {
    return {
      style: {
        'vertical-align': 'middle',
        overflow: 'hidden',
      }
    }
  }
}
</script>